<div class="company-list-container">
  <div class="company-list-header">
    <h2 class="company-list-header__title">Companies</h2>
    <div class="company-list-header__actions">
      <div class="company-filter__container">
        <p-floatlabel variant="on">
          <p-select
            [(ngModel)]="companyFilter"
            [options]="sortedCompanyNames()"
            [showClear]="true"
            class="company-name-filter"
          ></p-select>
          <label for="status">Company filter</label>
        </p-floatlabel>
      </div>

      <p-button
        label="Create company"
        icon="pi pi-plus"
        aria-label="Add license"
        raised
        (click)="handleAddCompanyClick()"
      />
    </div>
  </div>

  <section class="company-list-items">
    @if(companies$().length > 0) {

    <p-accordion>
      @for (company of filteredCompanies(); track company.id) {
      <p-accordion-panel [value]="company.id">
        <p-accordion-header>
          <div class="company-item-header">
            <div class="company-item-header__logo-img">
              @if(company.logo) {
              <img [src]="company.logo" [alt]="company.logo" loading="lazy" />
              }
            </div>
            <div class="company-item-header__name">
              {{ company.name }}
            </div>
            <div class="company-item-header__logo-path">
              @if(company.logo) {
              <a
                [href]="company.logo"
                [title]="company.logo"
                target="_blank"
                (click)="$event.stopPropagation()"
                >{{ company.logo }}</a
              >
              }
            </div>
            <div class="company-item-header__actions">
              <p-button
                label="Edit"
                icon="pi pi-pencil"
                aria-label="Edit"
                severity="secondary"
                raised
                (click)="handleEditCompanyClick($event, company)"
              />
              <p-button
                label="Delete"
                icon="pi pi-trash"
                aria-label="Delete"
                severity="danger"
                raised
                (click)="handleDeleteCompanyClick($event, company.id)"
              />
            </div>
          </div>
        </p-accordion-header>
        <p-accordion-content class="company-item-content">
          <p-card class="license-list-container" header="Licenses">
            <ng-template #title>
              <div class="license-card__title">
                <span>Licenses</span>
                <p-button
                  label="Add license"
                  size="small"
                  icon="pi pi-plus"
                  aria-label="Add license"
                  raised
                  (click)="handleAddLicenseClick(company.id)"
                />
              </div>
            </ng-template>
            <cognos-license-list
              [companyName]="company.name"
              [licenses]="company.licenses"
              (onEditLicense)="handleEditLicense($event, company.id)"
            ></cognos-license-list>
          </p-card>
        </p-accordion-content>
      </p-accordion-panel>
      }
    </p-accordion>
    <p-confirmdialog />
    } @else {
    <p>There are no companies yet.</p>
    }

    <cognos-company-form-dialog
      [company]="companyToEdit"
      [(isOpen)]="isAddCompanyDialogVisible"
    ></cognos-company-form-dialog>

    <cognos-license-form-dialog
      [companyId]="selectedCompanyId"
      [(license)]="selectedLicense"
      [(isOpen)]="isAddLicenseDialogVisible"
    ></cognos-license-form-dialog>
  </section>
</div>
